"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import * as React from "react";
import WaitingSpinner from "../../components/waiting_spinner";
const DEFAULT_NOTE_SETTINGS = [
  { type: "warning", display: "expanded" },
  { type: "verification_notes", display: "closed" },
  { type: "funding_notes", display: "expanded" },
  { type: "notes", display: "expanded" }
];
function parseNotes(text) {
  if (!text || typeof text !== "string") return [];
  return text.split("\n").map((line) => line.trim()).filter((line) => line.length > 0);
}
function getSectionLabel(type) {
  switch (type) {
    case "warning":
      return "WARNING";
    case "verification_notes":
      return "VERIFICATION NOTES";
    case "funding_notes":
      return "FUNDING";
    case "notes":
      return "NOTES";
    default:
      return type.toUpperCase();
  }
}
function getSectionContentClass(type) {
  switch (type) {
    case "warning":
      return "client-notes-sidebar-section__content client-notes-sidebar-section__content--warning";
    case "verification_notes":
      return "client-notes-sidebar-section__content client-notes-sidebar-section__content--verification";
    case "funding_notes":
      return "client-notes-sidebar-section__content client-notes-sidebar-section__content--funding";
    default:
      return "client-notes-sidebar-section__content";
  }
}
function getNoteClass(type) {
  switch (type) {
    case "funding_notes":
      return "client-notes-sidebar-note client-notes-sidebar-note--funding";
    default:
      return "client-notes-sidebar-note";
  }
}
function getPillClass(type) {
  switch (type) {
    case "warning":
      return "client-notes-sidebar-section__pill client-notes-sidebar-section__pill--warning";
    case "verification_notes":
      return "client-notes-sidebar-section__pill client-notes-sidebar-section__pill--verification";
    case "funding_notes":
      return "client-notes-sidebar-section__pill client-notes-sidebar-section__pill--funding";
    default:
      return "client-notes-sidebar-section__pill client-notes-sidebar-section__pill--notes";
  }
}
function getNotesByType(props, type) {
  switch (type) {
    case "warning":
      return parseNotes(props.warning);
    case "verification_notes":
      return parseNotes(props.verificationInstructions);
    case "funding_notes":
      return parseNotes(props.fundingNotes);
    case "notes":
      return parseNotes(props.notes);
    default:
      return [];
  }
}
function renderTitleBar(props) {
  const settings = props.noteSettings || DEFAULT_NOTE_SETTINGS;
  const totalCount = settings.filter((s) => s.display !== "hide").reduce((acc, s) => {
    return acc + getNotesByType(props, s.type).length;
  }, 0);
  return /* @__PURE__ */ React.createElement("h3", null, "Client Notes", totalCount > 0 && /* @__PURE__ */ React.createElement("span", { className: "client-notes-sidebar-count" }, totalCount));
}
const ClientNotesSidebar = React.createClass({
  getInitialState: function() {
    const settings = this.props.noteSettings || DEFAULT_NOTE_SETTINGS;
    const expandedSections = {};
    settings.forEach((s) => {
      expandedSections[s.type] = s.display !== "closed";
    });
    return { expandedSections };
  },
  toggleSection: function(type) {
    this.setState((prev) => ({
      expandedSections: __spreadProps(__spreadValues({}, prev.expandedSections), {
        [type]: !prev.expandedSections[type]
      })
    }));
  },
  renderContent: function() {
    if (this.props.loading) {
      return /* @__PURE__ */ React.createElement(WaitingSpinner, null);
    }
    const settings = this.props.noteSettings || DEFAULT_NOTE_SETTINGS;
    const visibleSettings = settings.filter((s) => s.display !== "hide");
    const totalCount = visibleSettings.reduce((acc, s) => {
      return acc + getNotesByType(this.props, s.type).length;
    }, 0);
    if (totalCount === 0) {
      return /* @__PURE__ */ React.createElement("div", { key: "no-notes" }, "No notes available");
    }
    return /* @__PURE__ */ React.createElement("div", { key: `notes-${totalCount}` }, visibleSettings.map((setting) => {
      const noteList = getNotesByType(this.props, setting.type);
      if (noteList.length === 0) return null;
      const isExpanded = this.state.expandedSections[setting.type];
      return /* @__PURE__ */ React.createElement("div", { key: setting.type, className: "client-notes-sidebar-section" }, /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "client-notes-sidebar-section__header",
          onClick: () => this.toggleSection(setting.type)
        },
        /* @__PURE__ */ React.createElement("div", { className: "client-notes-sidebar-section__header-left" }, /* @__PURE__ */ React.createElement("span", { className: getPillClass(setting.type) }), /* @__PURE__ */ React.createElement("span", { className: "client-notes-sidebar-section__title" }, getSectionLabel(setting.type)), !isExpanded && /* @__PURE__ */ React.createElement("span", { className: "client-notes-sidebar-section__count" }, noteList.length)),
        /* @__PURE__ */ React.createElement("i", { className: isExpanded ? "fi-minus" : "fi-plus" })
      ), isExpanded && /* @__PURE__ */ React.createElement("div", { className: getSectionContentClass(setting.type) }, noteList.map((note, index) => /* @__PURE__ */ React.createElement("div", { key: index, className: getNoteClass(setting.type) }, note))));
    }));
  },
  render: function() {
    if (!this.props.isOpen) {
      return null;
    }
    return /* @__PURE__ */ React.createElement("div", { className: "client-notes-sidebar-wrapper" }, /* @__PURE__ */ React.createElement("div", { className: "client-notes-sidebar-panel" }, /* @__PURE__ */ React.createElement("div", { className: "client-notes-sidebar-header" }, renderTitleBar(this.props), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "client-notes-sidebar-close",
        title: "Close",
        onClick: this.props.onToggle
      },
      /* @__PURE__ */ React.createElement("i", { className: "fi-x" })
    )), /* @__PURE__ */ React.createElement("div", { className: "client-notes-sidebar-content" }, this.renderContent())));
  }
});
function ClientNotesSidebarTrigger(props) {
  const settings = props.noteSettings || DEFAULT_NOTE_SETTINGS;
  const visibleSettings = settings.filter((s) => s.display !== "hide");
  const notesByType = {
    warning: parseNotes(props.warning),
    verification_notes: parseNotes(props.verificationInstructions),
    funding_notes: parseNotes(props.fundingNotes),
    notes: parseNotes(props.notes)
  };
  const totalCount = visibleSettings.reduce((acc, s) => {
    return acc + (notesByType[s.type] || []).length;
  }, 0);
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "client-notes-sidebar-trigger",
      title: "Open Notes",
      onClick: props.onToggle
    },
    /* @__PURE__ */ React.createElement("i", { className: "fi-clipboard-notes" }),
    totalCount > 0 && /* @__PURE__ */ React.createElement("span", { className: "client-notes-sidebar-trigger-count" }, totalCount)
  );
}
export default ClientNotesSidebar;
export { ClientNotesSidebarTrigger };
